export default __webpack_public_path__ + "static/media/audio.8049852c.wav";